import React from 'react';
import styled from 'styled-components';

import { AccountDetails } from './components/account-details';
// import Button from '@atlaskit/button';
// import CrossIcon from '@atlaskit/icon/glyph/cross';
// import { N500 } from '@atlaskit/theme/colors';
// import { token } from '@atlaskit/tokens';
import { fontFamily } from '@atlaskit/theme';
import { OrganizationSelectorForm } from './components/organization-selector-form';

export type OrganizationSelectorViewProps = {
  readonly userName: string;
  readonly userEmail: string;
  readonly organizations: string[];

  readonly header?: React.ReactNode;

  readonly onNewOrganizationSelected: () => void;
  readonly onOrganizationSelected: (organization: string) => void;
  readonly onOrganizationChanged: () => void;
  readonly onSwitchAccountClick: () => void;
  readonly onCancelClick: () => void;

  readonly avatarSrc?: string;
  readonly fullScreenView?: boolean;
};

export function OrganizationSelectorView({
  userName,
  userEmail,
  organizations,
  avatarSrc,
  onNewOrganizationSelected,
  onOrganizationSelected,
  onSwitchAccountClick,
  onCancelClick,
  onOrganizationChanged,
  fullScreenView
}: OrganizationSelectorViewProps) {
  return (
    <RootContainer>
      <AvatarContainer>
        <AccountDetails
          userName={userName}
          userEmail={userEmail}
          avatarSrc={avatarSrc}
        />
      </AvatarContainer>
      <OrganizationSelectorForm
        organizations={organizations}
        onNewOrganizationSelected={onNewOrganizationSelected}
        onOrganizationSelected={onOrganizationSelected}
        onSwitchAccountClick={onSwitchAccountClick}
        onCancelClick={onCancelClick}
        onOrganizationChanged={onOrganizationChanged}
        fullScreenView={fullScreenView}
      />
    </RootContainer>
  );
}

const RootContainer = styled.div`
  font-family: ${fontFamily};
`;

const AvatarContainer = styled.div`
  margin: 20px 0px;
`;
